import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Mail } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ApplicationComingSoonDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ApplicationComingSoonDialog = ({ open, onOpenChange }: ApplicationComingSoonDialogProps) => {
  const { t } = useTranslation('landing');

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-sm">
        <AlertDialogHeader className="items-center text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-6 w-6 text-primary" />
          </div>
          <AlertDialogTitle className="text-lg">{t('coming_soon.title')}</AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground">
            {t('coming_soon.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center">
          <AlertDialogAction className="bg-primary hover:bg-primary/90 px-8">
            {t('coming_soon.got_it')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
